import React from 'react'
import {
  BaseComponent
} from 'belle-js'
import Tab from 'components/Shared/Tab/Tab'
import styles from './TabbedForm.module.scss'

const withTabbedForm = (WrappedFormComponent) => {
  class TabbedForm extends BaseComponent {

    componentWillReceiveProps (nextProps) {
      if (this.props.isSubmitting && !nextProps.isSubmitting) {
        // Respond to BelleForm events here
        if (nextProps.submitSucceeded) {
          // On Success
          this.props.successHandler(nextProps.responseData)
        } else if (nextProps.submitFailed) {
          // On Failure
        }
      }
    }

    render () {
      const {
        currentSelectedTab,
        isMobile,
        onChangeSelectedTab,
        tabList,
        isFormValid,
      } = this.props
      return (
        <div className={styles.tabbedForm}>
          <div className={styles.tab}>
            <Tab
              items={tabList}
              selectedTab={currentSelectedTab}
              isMobile={isMobile} 
              isFormValid={isFormValid}
              onSelectTab={onChangeSelectedTab} />
          </div>
          <div className={styles.formSection}>
            <WrappedFormComponent {...this.props} />
          </div>
        </div>
      )
    }

  }
  return TabbedForm
}

export default withTabbedForm



// WEBPACK FOOTER //
// ./src/components/Shared/withTabbedForm/index.js